export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/arrow-left.0cb91e0a-14fd0f.svg";